<template>
    <span>
        <svg :viewBox="`0 0 ${svg_width} ${svg_height}`" height="50" width="50" style="float: right">
            <g v-for="(image, idx) in imagePositions" :key="idx">
                <image
                    :href="image.src"
                    :x="image.x - image.r"
                    :y="image.y - image.r"
                    :width="image.r * 2"
                    :height="image.r * 2"
                />
            </g>
        </svg>
    </span>
</template>

<script>
import { getSpeciesImage, imageLayoutFor } from "@/species.js";

export default {
   name: "Species",
    props: {
        species: {
            type: Array,
            default: () => []
        },
        width: {
            type: Number,
            default: 50,
        },
        height: {
            type: Number,
            default: 50,
        }
    },
    created() {
        this.svg_width = 420;
        this.svg_height = 420;
    },
    async mounted() {
        let images = (await Promise.all(this.species.map((name) => getSpeciesImage(name)))).filter(image => image !== 'help');

        this.imagePositions = imageLayoutFor(images.length);
        this.imagePositions = this.imagePositions.map((pos, idx) => {
            return {
                src: images[idx],
                x: pos.x,
                y: pos.y,
                r: pos.r,
            }
        });
    },
    data() {
        return {
            imagePositions: this.imagePositions,
            svg_width: this.svg_width,
            svg_height: this.svg_height,
        }
    }
}
</script>
